import React, { useEffect, useState } from "react";
import BreedMenuItem from "../../assets/json/phenomenu";
import DataBaseList from "../../assets/json/DataBase";
import {  Layout, Menu, theme, Button } from "antd";
import { ReactComponent as SlideFalseIcon } from "../../assets/icon/收回.svg";
import { ReactComponent as SlideTrueIcon } from "../../assets/icon/展开.svg";
import styled from 'styled-components';
import { useLocation } from "react-router-dom";
// import './breedmenu.css'
const { Sider } = Layout;
const CustomMenu = styled(Menu)`
  .ant-menu-item-selected {
    background-color: #E1E7D9 !important; /* 修改背景色 */
    color: #000 !important; /* 修改字体颜色 */
  }

  .ant-menu-item:hover {
    background-color: #E1E7D9 !important; /* 修改背景色 */
    color: #000 !important; /* 修改字体颜色 */
  }
`;
function PhenoMenuComp() {
  const location=useLocation()
  const [RoleValue, setRoleValue] = useState(sessionStorage.getItem("role"));
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const [BreedCurrent, setBreedCurrent] = useState(
    sessionStorage.getItem("PhenoMenuKey")
     ||'left1'
  );
  const BreedClick = (e) => {
    sessionStorage.setItem("PhenoMenuKey", e.key);
  };
  useEffect(()=>{
    setBreedCurrent(sessionStorage.getItem("PhenoMenuKey"))
  },[sessionStorage.getItem("PhenoMenuKey")])
  const [collapsed, setCollapsed] = useState(false);
   
  return (
    <Sider
      style={{
        background: colorBgContainer,
        position:"relative",
        fontWeight:"bold",
        height:"100%"

      }}
      width={240}
      collapsed={collapsed}
      onCollapse={setCollapsed}
      collapsedWidth={5}
    >
      <CustomMenu
        mode="inline"
        selectedKeys={[BreedCurrent]}
        onClick={BreedClick}
        style={{
          height: "100%",
        }}
        items={RoleValue=="A"?BreedMenuItem:DataBaseList}
      />
        <Button
        ghost
        style={{
          width: "52px",
          heightL: "52px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border:"none",
          position:"absolute",
          top:"40%",
          right:"-30px",
          background:"transparent"
        }}
        onClick={()=>{
          setCollapsed(!collapsed);
        }}
      >
        {
          collapsed?<SlideTrueIcon width={25}/>:<SlideFalseIcon width={25} />
        }
      </Button>
    </Sider>
  );
}

export default PhenoMenuComp;
